module.exports = __webpack_public_path__ + "img/logout.4ef41b8d.svg";